export default "__VITE_ASSET__QVND7_Kx__"